import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#0F172A] text-slate-400 py-12 text-center text-sm" data-id="element-14">
        <div className="container mx-auto px-4" data-id="element-15">
          <p className="mb-4" data-id="element-16">
            &copy; {new Date().getFullYear()} Enfoque de Acero. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-17">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors cursor-pointer" data-id="element-18">
              Términos de Uso
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-19">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-20">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-21">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-slate-100 sticky top-0 bg-white rounded-t-2xl" data-id="element-22">
              <h2 className="text-xl font-bold text-[#1B3A6B]" data-id="element-23">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Uso'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-slate-100 transition-colors text-slate-500 hover:text-slate-800" data-id="element-24">
                <X className="h-5 w-5" data-id="element-25" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 text-slate-700 text-sm leading-relaxed space-y-4" data-id="element-26">
              {activeModal === 'privacy' ? <>
                  <p className="text-slate-500 text-xs" data-id="element-27">
                    Última actualización: {new Date().getFullYear()}
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-28">
                    1. Información que recopilamos
                  </h3>
                  <p data-id="element-29">
                    Enfoque de Acero recopila únicamente la información
                    necesaria para procesar tu compra y entregarte el producto
                    digital. Esto incluye tu nombre y dirección de correo
                    electrónico proporcionados durante el proceso de pago.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-30">
                    2. Uso de la información
                  </h3>
                  <p data-id="element-31">
                    La información recopilada se utiliza exclusivamente para:
                    (a) procesar y confirmar tu compra, (b) entregarte acceso al
                    producto digital, y (c) enviarte comunicaciones relacionadas
                    con tu compra.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-32">
                    3. Protección de datos
                  </h3>
                  <p data-id="element-33">
                    No vendemos, alquilamos ni compartimos tu información
                    personal con terceros. Utilizamos medidas de seguridad
                    estándar de la industria para proteger tu información.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-34">
                    4. Cookies
                  </h3>
                  <p data-id="element-35">
                    Este sitio puede utilizar cookies técnicas necesarias para
                    su funcionamiento. No utilizamos cookies de rastreo de
                    terceros con fines publicitarios.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-36">
                    5. Tus derechos
                  </h3>
                  <p data-id="element-37">
                    Tienes derecho a acceder, corregir o solicitar la
                    eliminación de tus datos personales en cualquier momento.
                  </p>
                </> : <>
                  <p className="text-slate-500 text-xs" data-id="element-38">
                    Última actualización: {new Date().getFullYear()}
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-39">
                    1. Aceptación de los términos
                  </h3>
                  <p data-id="element-40">
                    Al adquirir Enfoque de Acero, aceptas estos Términos de Uso
                    en su totalidad. Si no estás de acuerdo con alguno de estos
                    términos, no debes utilizar este producto.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-41">
                    2. Licencia de uso
                  </h3>
                  <p data-id="element-42">
                    Al comprar este producto, recibes una licencia personal, no
                    transferible y no exclusiva para usar el contenido
                    únicamente para tu uso personal. Queda estrictamente
                    prohibida la reproducción, distribución o reventa del
                    material.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-43">
                    3. Propiedad intelectual
                  </h3>
                  <p data-id="element-44">
                    Todo el contenido de Enfoque de Acero, incluyendo textos,
                    gráficos, metodologías y materiales, es propiedad exclusiva
                    de Enfoque de Acero y está protegido por las leyes de
                    derechos de autor aplicables.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-45">
                    4. Resultados
                  </h3>
                  <p data-id="element-46">
                    Los resultados descritos son ejemplos de lo que es posible.
                    Los resultados individuales variarán dependiendo de la
                    dedicación, el punto de partida y otros factores. No
                    garantizamos resultados específicos.
                  </p>
                  <h3 className="font-bold text-[#1B3A6B] text-base" data-id="element-47">
                    5. Limitación de responsabilidad
                  </h3>
                  <p data-id="element-48">
                    Enfoque de Acero no será responsable por ningún daño
                    indirecto, incidental o consecuente que surja del uso o la
                    imposibilidad de usar este producto.
                  </p>
                </>}
            </div>
          </div>
        </div>}
    </>;
}